/**
 * @name toLowerCase
 * @description This function transforms the string in lower case
 * @param {string} stringValue The string to transform.
 * @returns {string} The string formatted
 *
 * @example
 * import {toLowerCase} from 'gso-utilities';
 * const myString = 'Hulk';
 *  const transformed = toLowerCase(myString);
 * console.log(transformed); // hulk
 */
function toLowerCase(stringValue) {
    return stringValue.toLowerCase();
}
export { toLowerCase };
//# sourceMappingURL=to-lower-case.js.map